<section class="w-100 h-12">
    <nav class="navBar">
        <div class="d-flex align-items-center w-30">
            <button class="btn-bar" (click)="confirmar()">
                <object data="assets/agview-connect/check.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.NAVBAR.CONFIRM" | transloco }}
                </object>
            </button>
            <img class="premoplan-logo" src="assets/imagens/logo-branca-completa.png" alt="logo-premoplan">
        </div>
        <div class="w-25 d-flex justify-content-end align-items-center">
            <div class="d-flex flex-column justify-content-center spacing-gap-1 padding-right-05">
                <div class="d-flex spacing-gap-2">
                    <object class="user-svg" data="assets/agview-connect/user.svg" type="image/svg+xml">
                        {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.NAVBAR.USER" | transloco }}
                    </object>
                    <span>{{ nomeUsuario }}</span>
                </div>
                <div class="d-flex spacing-gap-1">
                    <span>15:32</span>
                    <span>02/12/2024</span>
                </div>
            </div>
        </div>
    </nav>
</section>